exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-godsman-tsx": () => import("./../../../src/pages/godsman.tsx" /* webpackChunkName: "component---src-pages-godsman-tsx" */),
  "component---src-pages-godsmanomeire-tsx": () => import("./../../../src/pages/godsmanomeire.tsx" /* webpackChunkName: "component---src-pages-godsmanomeire-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

